import React from 'react';
import { FaFacebookF, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { TbWorld } from 'react-icons/tb';
import SocialButton from './SocialButton';

const SocialLinks = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-content animate-fade-in-up">
        <h2 className="section-title">مستعد للارتقاء بأعمالك؟</h2>
        <p className="section-subtitle">تواصل مع فريقنا اليوم وارتقِ بعملياتك الهندسية والمقاولات إلى المستوى التالي.</p>
        
        <div className="social-grid">
          <SocialButton 
            icon={<FaFacebookF size={28} />} 
            label="فيسبوك" 
            className="facebook" 
            url="https://facebook.com"
            delayClass="delay-100"
          />
          
          <SocialButton 
            icon={<FaInstagram size={30} />} 
            label="إنستغرام" 
            className="instagram" 
            url="https://instagram.com"
            delayClass="delay-200"
          />

          <SocialButton 
            icon={<TbWorld size={32} />} 
            label="موقعنا" 
            className="website" 
            url="https://google.com"
            delayClass="delay-300"
          />

          <SocialButton 
            icon={<FaWhatsapp size={32} />} 
            label="واتساب" 
            className="whatsapp" 
            url="https://wa.me/963984976756"
            delayClass="delay-400"
          />
        </div>
      </div>
    </section>
  );
};

export default SocialLinks;
